export default "__VITE_ASSET__B_lr5DVI__"